import {
  EQuarterlyDashboardViewMode,
  IQuarterlyDashboardMktCap,
  IQuarterlyDashboardQuarter,
  IQuarterlyDashboardSector,
  IQuarterlyDashboardSectorTop500,
} from '~/core/models'

import {
  QUARTERLY_DASHBOARD_DEFAULT_MKT_CAP_ORDER,
  QUARTERLY_DASHBOARD_DEFAULT_MKT_CAP_SORT_BY,
  QUARTERLY_DASHBOARD_DEFAULT_SECTOR_ORDER,
  QUARTERLY_DASHBOARD_DEFAULT_SECTOR_SORT_BY,
  QUARTERLY_DASHBOARD_DEFAULT_SECTOR_TOP500_ORDER,
  QUARTERLY_DASHBOARD_DEFAULT_SECTOR_TOP500_SORT_BY,
  QUARTERLY_DASHBOARD_DEFAULT_VIEW_MODE,
} from './quarterly-dashboard.constant'

export const quarterlyDashboardFeatureKey = 'QuarterlyDashboard prox'

export interface IQuarterlyDashboardQuarterState {
  initialized: boolean
  inRequest: boolean
  error?: Error
  data: IQuarterlyDashboardQuarter[]
  effective?: IQuarterlyDashboardQuarter
  selected?: IQuarterlyDashboardQuarter
}

export interface IQuarterlyDashboardMktCapState {
  initialized: boolean
  inRequest: boolean
  error?: Error
  data: IQuarterlyDashboardMktCap[]
  quarter?: IQuarterlyDashboardQuarter
  sortBy: string
  order: 'asc' | 'desc' | ''
}

export interface IQuarterlyDashboardSectorState {
  initialized: boolean
  inRequest: boolean
  error?: Error
  data: IQuarterlyDashboardSector[]
  quarter?: IQuarterlyDashboardQuarter
  sortBy: string
  order: 'asc' | 'desc' | ''
}

export interface IQuarterlyDashboardSectorTop500State {
  initialized: boolean
  inRequest: boolean
  error?: Error
  data: IQuarterlyDashboardSectorTop500[]
  quarter?: IQuarterlyDashboardQuarter
  sortBy: string
  order: 'asc' | 'desc' | ''
}

export interface IQuarterlyDashboardState {
  quarter: IQuarterlyDashboardQuarterState
  mktCap: IQuarterlyDashboardMktCapState
  sector: IQuarterlyDashboardSectorState
  sectorTop500: IQuarterlyDashboardSectorTop500State
  viewMode: EQuarterlyDashboardViewMode
}

export const createQuarterlyDashboardInitState = (): IQuarterlyDashboardState => ({
  quarter: {
    initialized: false,
    inRequest: false,
    data: [],
    effective: undefined,
    selected: undefined,
  },
  mktCap: {
    initialized: false,
    inRequest: false,
    data: [],
    quarter: undefined,
    sortBy: QUARTERLY_DASHBOARD_DEFAULT_MKT_CAP_SORT_BY,
    order: QUARTERLY_DASHBOARD_DEFAULT_MKT_CAP_ORDER,
  },
  sector: {
    initialized: false,
    inRequest: false,
    data: [],
    quarter: undefined,
    sortBy: QUARTERLY_DASHBOARD_DEFAULT_SECTOR_SORT_BY,
    order: QUARTERLY_DASHBOARD_DEFAULT_SECTOR_ORDER,
  },
  sectorTop500: {
    initialized: false,
    inRequest: false,
    data: [],
    quarter: undefined,
    sortBy: QUARTERLY_DASHBOARD_DEFAULT_SECTOR_TOP500_SORT_BY,
    order: QUARTERLY_DASHBOARD_DEFAULT_SECTOR_TOP500_ORDER,
  },
  viewMode: QUARTERLY_DASHBOARD_DEFAULT_VIEW_MODE,
})

export interface IAppWithQuarterlyDashboardState {
  quarterlyDashboard: IQuarterlyDashboardState
}
